import axios from 'axios';
import type {
  BindWorkflowTagRequest,
  BindWorkflowTagResponse,
  CreateWorkflowTagRequest,
  CreateWorkflowTagResponse,
  DeleteWorkflowTagRequest,
  DeleteWorkflowTagResponse,
  ListWorkflowTagsRequest,
  ListWorkflowTagsResponse,
  UnbindWorkflowTagRequest,
  UnbindWorkflowTagResponse,
  UpdateWorkflowTagRequest,
  UpdateWorkflowTagResponse,
} from '@/types/workflow-tag';

/**
 * 绑定工作流标签
 */
export function bindWorkflowTagApi(data: BindWorkflowTagRequest) {
  return axios.post<BindWorkflowTagResponse>(
    '/api/console/workflow/v1/tag/bind',
    data
  );
}

/**
 * 创建工作流标签
 */
export function createWorkflowTagApi(data: CreateWorkflowTagRequest) {
  return axios.post<CreateWorkflowTagResponse>(
    '/api/console/workflow/v1/tag/create',
    data
  );
}

/**
 * 删除工作流标签
 */
export function deleteWorkflowTagApi(data: DeleteWorkflowTagRequest) {
  return axios.post<DeleteWorkflowTagResponse>(
    '/api/console/workflow/v1/tag/delete',
    data
  );
}

/**
 * 查询工作流标签列表
 */
export function listWorkflowTagsApi(data: ListWorkflowTagsRequest) {
  return axios.post<ListWorkflowTagsResponse>(
    '/api/console/workflow/v1/tag/list',
    data
  );
}

/**
 * 解绑工作流标签
 */
export function unbindWorkflowTagApi(data: UnbindWorkflowTagRequest) {
  return axios.post<UnbindWorkflowTagResponse>(
    '/api/console/workflow/v1/tag/unbind',
    data
  );
}

/**
 * 更新工作流标签
 */
export function updateWorkflowTagApi(data: UpdateWorkflowTagRequest) {
  return axios.post<UpdateWorkflowTagResponse>(
    '/api/console/workflow/v1/tag/update',
    data
  );
}

export default {
  bindWorkflowTagApi,
  createWorkflowTagApi,
  deleteWorkflowTagApi,
  listWorkflowTagsApi,
  unbindWorkflowTagApi,
  updateWorkflowTagApi,
};
